/**
 * Custom Video Hero Text Fade & Load Handling
 */
document.addEventListener('DOMContentLoaded', function () {
  var video = document.querySelector('.video-hero__container video');
  var text = document.querySelector('.video-hero__content');

  if (video && text) {
    // Initially hide the text or pause animation (make sure CSS is ready)
    text.style.opacity = '0';
    text.style.transition = 'opacity 1s ease';

    video.addEventListener('canplaythrough', function () {
      // Show the video (if hidden) and fade in text
      video.classList.add('loaded'); // optional class for further styling if needed
      text.style.opacity = '1';
    });

    // Optional: hide text again if video unloads (fallback)
    video.addEventListener('emptied', function () {
      text.style.opacity = '0';
    });
  }
});


/* DT RESPONSIVE SLIDESHOW LAZYLOAD FIX */
(function () {
  var lastMobileState = window.innerWidth <= 640;
  var resizeTimer = null;

  function unveilVisibleSlideshowImages() {
    if (!window.lazySizes || !window.lazySizes.loader) return;

    var images = document.querySelectorAll('.Slideshow__Image.Image--lazyLoad');

    Array.prototype.forEach.call(images, function (image) {
      var container = image.closest('.Slideshow__ImageContainer');
      if (!container) return;

      var style = window.getComputedStyle(container);
      if (style.display !== 'none' && style.visibility !== 'hidden' && image.getAttribute('data-src')) {
        window.lazySizes.loader.unveil(image);
      }
    });
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var isMobile = window.innerWidth <= 640;
      if (isMobile !== lastMobileState) {
        lastMobileState = isMobile;
        window.requestAnimationFrame(unveilVisibleSlideshowImages);
      }
    }, 100);
  });
})();


/* DT PRODUCT CARD AJAX CART FIX
   Keep collection/home/search Add to Cart inside the drawer.
   Product-page .ProductForm remains handled by the theme's native AJAX logic. */
(function () {
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.classList.contains('ProductForm')) return;

    var button = form.querySelector('.ProductItem__AddToCartButton');
    if (!button) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    event.preventDefault();
    if (button.disabled) return;

    button.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var data = new FormData(form);
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: data
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (payload) {
          throw new Error(payload && payload.description ? payload.description : 'Unable to add item to cart.');
        });
      }
      return response.json();
    }).then(function (item) {
      button.disabled = false;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: item,
          quantity: quantity
        }
      }));
    }).catch(function (error) {
      button.disabled = false;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      var oldError = form.querySelector('.DTAddToCartError');
      if (oldError) oldError.parentNode.removeChild(oldError);

      var errorNode = document.createElement('div');
      errorNode.className = 'DTAddToCartError Alert Alert--error';
      errorNode.setAttribute('role', 'alert');
      errorNode.textContent = error.message;
      button.insertAdjacentElement('afterend', errorNode);

      setTimeout(function () {
        if (errorNode.parentNode) errorNode.parentNode.removeChild(errorNode);
      }, 3000);
    });
  }, true);
})();
